import { Route } from '@angular/router';
import { AUTH_ROUTES } from '../common/constants/auth.routing.constants';
import { FEATURE_FLAGS } from '../common/constants/feature-flags.constants';
import { featureFlagGuard } from '../common/guards/feature-flag/feature-flag.guard';
import { onboardingResumeGuard } from '../common/guards/onboarding-resume/onboarding-resume.guard';
import { FEATURE_FLAG_KEY } from '../common/guards/path-allowed-by-feature-flag/path-allowed-by-feature-flag.guard';

export const authRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/' + AUTH_ROUTES.LOGIN,
  },
  {
    path: AUTH_ROUTES.LOGIN,
    loadComponent() {
      return import('../pages/auth/central-login/central-login.component').then(
        c => c.CentralLoginComponent
      );
    },
  },
  {
    path: AUTH_ROUTES.CREATE_PASSWORD,
    loadComponent() {
      return import('../pages/auth/create-password/create-password.component').then(
        c => c.CreatePasswordComponent
      );
    },
  },
  {
    path: AUTH_ROUTES.REGISTER,
    canActivate: [featureFlagGuard],
    data: { [FEATURE_FLAG_KEY]: FEATURE_FLAGS.AUTH.prospect_sign_up },
    loadComponent() {
      return import('../pages/auth/register/register.component').then(
        c => c.RegisterComponent
      );
    },
  },
  {
    path: AUTH_ROUTES.FORGET_PASSWORD + '/:mode',
    loadComponent() {
      return import('../pages/auth/forget-password/forget-password.component').then(
        c => c.ForgetPasswordComponent
      );
    },
  },
  {
    path: AUTH_ROUTES.CREATE_WORKSPACE,
    canActivate: [onboardingResumeGuard],
    loadComponent() {
      return import('../pages/auth/create-workspace/create-workspace.component').then(
        c => c.CreateWorkspaceComponent
      );
    },
  },
  {
    path: AUTH_ROUTES.WORKSPACE_SETUP + '/:id',
    loadComponent() {
      return import('../pages/auth/workspace-setup/workspace-setup.component').then(
        c => c.WorkspaceSetupComponent
      );
    },
  },
];
